(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/test/test-order-home-utils.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/test/test-order-home-utils.js');

svs.ticketsOrderHome.testData = {
  playerPreferencesData: {
    preferences: {
      30: {
        address: 'NORRA HANSEGATAN 17',
        county: 'Blekinge län',
        email: '194705059667@SVENSKASPEL.SE',
        emailStatus: '2',
        location: 'VISBY',
        name: 'Karl-Erik',
        postcode: '62180',
        surname: 'Karlsson',
        cid: '170891927'
      }
    },
    error: null
  },
  searchReceiversData: {
    results: [
      {
        firstName: 'Karl',
        lastName: 'Svensson',
        street: 'Gatan 10',
        careOf: '',
        zipCode: '12345',
        city: 'Staden',
        id: 'receiver-id-0'
      }
    ],
    error: null
  },
  searchReceiversOldData: {
    results: [
      {
        names: ['Karl', 'Erik'],
        indexPreferredName: 0,
        lastName: 'Svensson',
        street: 'Gatan 10',
        careOf: '',
        zipCode: '12345',
        city: 'Staden',
        id: 'receiver-id-0'
      }
    ],
    error: null
  },
  searchReceiversData25Results: {
    results: [],
    error: null
  },
  giftAddressData: {
    firstName: 'Benke',
    lastName: 'Benksson',
    street: 'NORRA HANSEGATAN 17',
    careOf: '',
    zipCode: '117 50',
    city: 'Testberga'
  }
};

for (let i = 0; i < 25; i++) {
  svs.ticketsOrderHome.testData.searchReceiversData25Results.results.push({
    ...svs.ticketsOrderHome.testData.searchReceiversData.results[0],
    id: `receiver-id-${i}`
  });
}

const TRISS_30_ID = '50';
const GOD_JUL_PAKET_ID = '46';
const TRISS_ADVENTSKALENDER_ID = '43';
const TEST_ORDER_REFERENCE_ID = '6b0efa5c-d13c-4acd-ad57-53bbf42d7fef';

const testOrderHomeUtils = () => {
  const { fireEvent, screen, within, waitFor } = TestingLibraryReact;
  const { orderHomePreviewCoverLetter } = svs.ticketsOrderHome.utils.constants;

  const callNext =
    (returns = {}) =>
      ({ next }) => {
        next(returns);
      };
  svs.tur.pay.account_services.playerSpelpaus = ({ next }) => {
    next();
  };
  svs.tur.pay.account_services.playerSpelpaus.CONSTANTS = {
    ALL: 'all',
    QUICK_GAMES: 'quickGames'
  };
  svs.tur.pay.account_services.playerSuspension = callNext();
  svs.tur.pay.account_services.dayTimeLimit = callNext();
  svs.tur.pay.account_services.accountBalance = callNext({ accountBalance: 1000 });
  svs.tur.pay.account_services.playerDepositLimits = callNext();
  svs.tur.pay.dialogs.confirmPayment = callNext();

  let localStorageStub;
  let getPlayerPreferencesStub;
  let searchReceiversStub;
  let postMailboxPlayerOrderStub;
  let postMailboxGiftOrderStub;
  let isLoggedInStub;
  let loginStub;
  let navigateStub;
  let urlMappingStub;
  let svsuidStub;
  let showErrorMessageStub;
  let querySelectorStub;

  const beforeEachStubs = () => {
    localStorageStub = sinon.stub(svs.components.Storage.browser, 'get');
    localStorageStub.returns([]);
    getPlayerPreferencesStub = sinon.stub(svs.ticketsOrderHome.services, 'getPlayerPreferences');
    getPlayerPreferencesStub.returns({ response: svs.ticketsOrderHome.testData.playerPreferencesData });
    searchReceiversStub = sinon.stub(svs.ticketsOrderHome.services, 'searchReceivers');
    searchReceiversStub.returns({ response: svs.ticketsOrderHome.testData.searchReceiversData });
    postMailboxPlayerOrderStub = sinon.stub(svs.tur.apiCaller.ticketgames, 'postMailboxPlayerOrder');
    let getOrderItemsResponse = {
      response: {
        orderItems: [],
        status: ''
      }
    };
    postMailboxPlayerOrderStub.callsFake(({ data }) => {
      getOrderItemsResponse.response = { ...data };
      return Promise.resolve({
        response: {
          ...data
        }
      });
    });
    mailBoxGetOrderStub = sinon.stub(svs.ticketsOrderHome.services, 'getOrder');
    mailBoxGetOrderStub.callsFake((referenceId) => {
      if (TEST_ORDER_REFERENCE_ID !== referenceId) {
        return { error: 'Order not found' };
      }
      return getOrderItemsResponse;
    });
    postMailboxGiftOrderStub = sinon.stub(svs.tur.apiCaller.ticketgames, 'postMailboxGiftOrder');
    let getOrderItemsGiftResponse = {
      response: {
        orderItems: [],
        status: ''
      }
    };
    postMailboxGiftOrderStub.callsFake(({ data }) => {
      getOrderItemsGiftResponse.response = {
        ...data,
        orderType: 1,
        giftAddress: svs.ticketsOrderHome.testData.giftAddressData
      };
      return Promise.resolve({
        response: {
          ...getOrderItemsGiftResponse.response
        }
      });
    });
    isLoggedInStub = sinon.stub(svs.core.userSession, 'hasRole');
    isLoggedInStub.returns(true);
    loginStub = sinon.stub(svs.components.customer_login, 'login');
    navigateStub = sinon.stub(svs.utils.url, 'navigate').returns(true);
    urlMappingStub = sinon.stub(svs.core.urlMapping, 'get').returnsArg(0);
    svsuidStub = sinon.stub(svs.utils, 'svsuid').returns(TEST_ORDER_REFERENCE_ID);
    showErrorMessageStub = sinon.stub(svs.ticketsOrderHome.utils, 'showErrorMessage');
    querySelectorStub = sinon.stub(document, 'querySelector').callsFake((selector) => {
      if (selector === '.js-drawer-sheet') {
        return {
          classList: {
            add: sinon.stub(),
            remove: sinon.stub()
          },
          style: {}
        };
      }
      return document.querySelector.wrappedMethod.call(document, selector);
    });
    return {
      localStorageStub,
      getPlayerPreferencesStub,
      searchReceiversStub,
      postMailboxPlayerOrderStub,
      postMailboxGiftOrderStub,
      mailBoxGetOrderStub,
      isLoggedInStub,
      loginStub,
      navigateStub,
      urlMappingStub,
      svsuidStub,
      showErrorMessageStub
    };
  };

  const afterEachStubs = () => {
    localStorageStub.restore();
    getPlayerPreferencesStub.restore();
    searchReceiversStub.restore();
    postMailboxPlayerOrderStub.restore();
    postMailboxGiftOrderStub.restore();
    mailBoxGetOrderStub.restore();
    isLoggedInStub.restore();
    loginStub.restore();
    navigateStub.restore();
    urlMappingStub.restore();
    svsuidStub.restore();
    showErrorMessageStub.restore();
    querySelectorStub.restore();
  };

  const waitForDividerPage = async () => {
    await waitFor(() => {
      screen.getByRole('heading', { name: svs.ticketsOrderHome.data.config.divider.topSection.headerTitle });
    });
  };

  const clickOrderHomeFromDivider = async () => {
    const orderHomeButton = screen.getByRole('button', { name: /köp triss/i });
    fireEvent.click(orderHomeButton);
  };

  const clickSubscribeFromDivider = async () => {
    const subscribeButton = screen.getByRole('button', { name: /prenumerera på triss/i });
    fireEvent.click(subscribeButton);
  };

  const waitForChoosePage = async () => {
    await waitFor(() => {
      screen.getByRole('heading', { name: svs.ticketsOrderHome.data.config.orderHome.orderHomeTitle });
    });
  };

  const waitForSearchResults = async () => {
    await waitFor(() => {
      screen.getByRole('heading', { name: /Sökresultat/i });
    });
  };

  const clickContinueButton = () => {
    const continueButton = screen.getByRole('button', { name: /fortsätt/i });
    fireEvent.click(continueButton);
  };

  const clickNavigationBack = () => {
    const navigationButton = screen.getByRole('button', { name: /beställ hem/i });
    fireEvent.click(navigationButton);
  };

  const waitForReceiverPage = async () => {
    await waitFor(() => {
      screen.getByRole('heading', { name: /Var ska lotterna skickas\?/i });
    });
  };

  const waitForMessagePage = async () => {
    await waitFor(() => {
      screen.getByRole('heading', { name: /Skicka med en hälsning/i });
    });
  };

  const waitForPreviewPage = async () => {
    await waitFor(() => {
      screen.getByRole('heading', { name: /lotterna skickas till/i });
    });
  };

  const shouldShowSearchForm = () => {
    screen.getByRole('heading', { name: /Sök efter mottagare/i });
    screen.getByRole('textbox', { name: /Förnamn\*/i });
    screen.getByRole('textbox', { name: /Efternamn\*/i });
    screen.getByRole('textbox', { name: /Gata/i });
    screen.getByRole('textbox', { name: /Postort\*/i });
    screen.getByRole('button', { name: /Sök/i });
  };

  const waitForPreviewCoverLetterPage = async () => {
    await waitFor(() => {
      screen.getByRole('heading', { name: orderHomePreviewCoverLetter.TITLE });
    });
  };

  const shouldContainName = () => {
    screen.getByText(/Karl-Erik Karlsson/);
  };

  const shouldContainAddress = () => {
    screen.getByText(/Karl-Erik Karlsson/);
    screen.getByText(/Norra Hansegatan 17/);
    screen.getByText(/62180 Visby/);
  };

  const shouldContainGiftAddress = () => {
    screen.getByText(/Benke Benksson/);
    screen.getByText(/Norra Hansegatan 17/);
    screen.getByText(/117 50 Testberga/);
  };

  const shouldHaveBuyMoreTicketsButton = () => {
    const button = screen.getByRole('button', { name: /Beställ fler lotter/i });
    button.click();
  };

  const shouldContainGiftBubbleWinMessage = (backendCacheExpired = false) => {
    screen.getByText(/Klart!/);
    if (backendCacheExpired) {
      screen.getByText(/Din present är nu på väg/);
    } else {
      screen.getByText(/Din present är nu på väg till Benke/);
    }
  };

  const shouldContainEmail = () => {
    screen.getByText(/194705059667@svenskaspel\.se/i);
  };

  const shouldContainAddressWithEmail = () => {
    shouldContainAddress();
    shouldContainEmail();
  };

  const shouldShowNeedHelpInfomation = () => {
    screen.getByRole('heading', { name: /behöver du hjälp\?/i });
  };

  const shouldShowWidgetArea = () => {
    should(document.querySelector('#stepByStepWidget')).not.eql(null, 'Widget area should be visible');
  };

  const shouldContainSummaryRows = ({ tickets, totalOrderPrice }) => {
    const summaryRows = document.querySelectorAll('.summary-row');
    should(summaryRows.length).eql(tickets.length + 3);
    const headerRow = summaryRows[0];
    should(headerRow.textContent).eql('Produkt:Antal (st):Summa:');
    tickets.forEach((ticket, index) => {
      const row = summaryRows[index + 1];
      should(row.textContent).eql(`${ticket.name}${ticket.count}${ticket.totalPrice} kr`);
    });
    const shippingRow = summaryRows[tickets.length + 1];
    should(shippingRow.textContent).eql(`Porto:${svs.ticketsOrderHome.utils.constants.SHIPPING_COST} kr`);
    const totalRow = summaryRows[tickets.length + 2];
    should(totalRow.textContent).eql(`Betalt:${totalOrderPrice} kr`);
  };

  const shouldButtonBeEnabled = (buttonName) => {
    const button = screen.getByRole('button', { name: buttonName });
    button.hasAttribute('disabled').should.be.False();
  };

  const shouldButtonBeDisabled = async (buttonName) => {
    const button = screen.getByRole('button', { name: buttonName });
    button.hasAttribute('disabled').should.be.True();
  };

  const clickPayButton = async (payAmount) => {
    const payButton = screen.getByRole('button', { name: `Betala ${payAmount} kr` });
    fireEvent.click(payButton);
    await waitFor(() => {});
  };

  const waitForConfirmationPage = async () => {
    await waitFor(() => {
      screen.getByRole('heading', { name: /beställningen levereras inom några dagar till:/i });
    });
  };

  const fillInSearchReceiverForm = ({ firstname, lastname, street, city } = {}) => {
    fireEvent.change(screen.getByLabelText(/Förnamn/i), { target: { value: firstname ?? 'Karl' } });
    fireEvent.change(screen.getByLabelText(/Efternamn/i), { target: { value: lastname ?? 'Svensson' } });
    fireEvent.change(screen.getByLabelText(/Gata/i), { target: { value: street ?? 'Gatan 10' } });
    fireEvent.change(screen.getByLabelText(/Postort/i), { target: { value: city ?? 'Staden' } });
  };

  const fillInMessageForm = (personalGreeting = 'Lycka till', message = 'ha en fin dag') => {
    fireEvent.change(screen.getByRole('textbox', { name: /din hälsning/i }), { target: { value: message } });
    screen.getAllByText(message).length.should.eql(2, 'should display personal greeting in textbox and preview card');

    fireEvent.change(screen.getByRole('combobox'), { target: { value: personalGreeting } });
    screen.getByText(`${personalGreeting}!`);
    screen.getByText(personalGreeting);
  };

  const clickSearchButton = () => {
    const searchButton = screen.getByRole('button', { name: /Sök/i });
    fireEvent.click(searchButton);
  };

  const clickSearchResult = (index = 0) => {
    const searchResult = screen.getByTestId(`search-result-${index}`);
    fireEvent.click(searchResult);
  };

  const waitForDelayedClick = async () => {
    await waitFor(() => {
      should.exist(screen.getByRole('heading', { name: /mottagare/i }));
    });
  };

  const shouldSearchReceiversBeCalled = ({ firstname, lastname, street, city } = {}) => {
    searchReceiversStub
      .calledWith({
        firstName: firstname ?? 'Karl',
        lastName: lastname ?? 'Svensson',
        street: street ?? 'Gatan 10',
        city: city ?? 'Staden'
      })
      .should.be.True();
  };

  const incrementOrderCountForTicket = (ticketId) => {
    const ticketEnvelope = screen.getByTestId(`ticket-envelope-${ticketId}`);
    const incrementButton = within(ticketEnvelope).getAllByRole('button')[1];
    incrementButton.click();
  };

  const decrementOrderCountForTicket = (ticketId) => {
    const ticketEnvelope = screen.getByTestId(`ticket-envelope-${ticketId}`);
    const decrementButton = within(ticketEnvelope).getAllByRole('button')[0];
    decrementButton.click();
  };

  const getTicketOrderCount = (ticketId) => {
    const ticketEnvelope = screen.getByTestId(`ticket-envelope-${ticketId}`);
    return within(ticketEnvelope).getByTestId('ticket-order-count').textContent;
  };

  const incrementOrderCountForTicketInCart = (ticketId) => {
    const cartBottomSheet = screen.getByTestId('cart-bottom-sheet-body');
    const ticketEnvelope = within(cartBottomSheet).getByTestId(`cart-ticket-${ticketId}`);
    const incrementButton = within(ticketEnvelope).getAllByRole('button')[1];
    incrementButton.click();
  };

  const decrementOrderCountForTicketInCart = (ticketId) => {
    const cartBottomSheet = screen.getByTestId('cart-bottom-sheet-body');
    const ticketEnvelope = within(cartBottomSheet).getByTestId(`cart-ticket-${ticketId}`);
    const decrementButton = within(ticketEnvelope).getAllByRole('button')[0];
    decrementButton.click();
  };

  const getTicketOrderCountInCart = (ticketId) => {
    const cartBottomSheet = screen.getByTestId('cart-bottom-sheet-body');
    const ticketEnvelope = within(cartBottomSheet).getByTestId(`cart-ticket-${ticketId}`);
    return within(ticketEnvelope).getByTestId('ticket-order-count').textContent;
  };

  const cartSummaryShouldContain = (count, sum) => {
    const footer = screen.getByTestId('cart-bottom-sheet-footer');
    const summaryList = within(footer).getAllByRole('listitem');
    should(summaryList[0].textContent).eql(`Antal:${count} st`);
    should(summaryList[1].textContent).eql(`Porto:10 kr`);
    should(summaryList[2].textContent).eql(`Summa:${sum} kr`);
  };

  const expandedCartBottomSheet = async () => {
    const bottomSheetDragHandleButton = document.querySelector('.js-bottom-sheet-draggable');
    const touch = new Touch({
      identifier: 1,
      target: bottomSheetDragHandleButton,
      screenY: 100
    });
    fireEvent.touchStart(bottomSheetDragHandleButton, { changedTouches: [touch] });
    fireEvent.touchEnd(bottomSheetDragHandleButton, { changedTouches: [touch] });
    await waitFor(() => {
      screen.getByTestId('cart-bottom-sheet-body');
    });
  };

  const switchToSearchOtherReceiver = async () => {
    const searchOtherReceiverButton = screen.getByRole('radio', { name: /Till någon annan/i });
    fireEvent.click(searchOtherReceiverButton);
  };

  const gotoReceiverPage = async (orderTickets = [{ id: TRISS_ADVENTSKALENDER_ID, count: 1 }]) => {
    await waitForDividerPage();
    clickOrderHomeFromDivider();
    await waitForChoosePage();
    orderTickets.forEach((ticket) => {
      for (let i = 0; i < ticket.count; i++) {
        incrementOrderCountForTicket(ticket.id);
      }
    });
    clickContinueButton();
    await waitForReceiverPage();
  };

  const gotoConfirmationPage = async (orderTickets = [{ id: TRISS_ADVENTSKALENDER_ID, count: 1 }]) => {
    await waitForDividerPage();
    clickOrderHomeFromDivider();
    await waitForChoosePage();
    let totalOrderPrice = 10;
    orderTickets.forEach((ticket) => {
      const price = svs.ticketsOrderHome.data.config.orderHome.tickets.find((t) => t.id === ticket.id).price;
      totalOrderPrice += ticket.count * price;
      for (let i = 0; i < ticket.count; i++) {
        incrementOrderCountForTicket(ticket.id);
      }
    });
    clickContinueButton();
    await waitForReceiverPage();
    await clickPayButton(totalOrderPrice);
    await waitForConfirmationPage();
  };

  const createTransactionItem = ({ productName, productCode, count, price, category }) => ({
    SKU: productCode,
    productName,
    price: parseFloat(price).toFixed(2),
    quantity: count,
    category
  });
  const createTransactionItems = (items) => items.map((item) => createTransactionItem(item));

  return {
    afterEachStubs,
    beforeEachStubs,
    clickNavigationBack,
    clickOrderHomeFromDivider,
    clickSubscribeFromDivider,
    clickContinueButton,
    shouldShowSearchForm,
    shouldContainName,
    shouldContainAddress,
    shouldContainGiftAddress,
    shouldHaveBuyMoreTicketsButton,
    shouldContainGiftBubbleWinMessage,
    shouldContainEmail,
    shouldContainAddressWithEmail,
    shouldShowNeedHelpInfomation,
    shouldShowWidgetArea,
    shouldContainSummaryRows,
    shouldButtonBeEnabled,
    shouldButtonBeDisabled,
    clickPayButton,
    waitForDividerPage,
    waitForChoosePage,
    waitForPreviewPage,
    waitForReceiverPage,
    waitForConfirmationPage,
    waitForSearchResults,
    gotoReceiverPage,
    waitForMessagePage,
    waitForPreviewCoverLetterPage,
    gotoConfirmationPage,
    fillInSearchReceiverForm,
    clickSearchButton,
    clickSearchResult,
    waitForDelayedClick,
    shouldSearchReceiversBeCalled,
    fillInMessageForm,
    incrementOrderCountForTicket,
    decrementOrderCountForTicket,
    getTicketOrderCount,
    incrementOrderCountForTicketInCart,
    decrementOrderCountForTicketInCart,
    getTicketOrderCountInCart,
    cartSummaryShouldContain,
    expandedCartBottomSheet,
    switchToSearchOtherReceiver,
    createTransactionItems,
    TRISS_30_ID,
    GOD_JUL_PAKET_ID,
    TRISS_ADVENTSKALENDER_ID,
    TEST_ORDER_REFERENCE_ID
  };
};
svs.ticketsOrderHome.testUtils = testOrderHomeUtils;


 })(window);